import $ from 'jquery';
import BackgroundImage from './BackgroundImage';

export default class GetStarted {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.BackgroundImage = this.addBackgroundImage();
    this.ready();
  }

  addBackgroundImage() {
    return new BackgroundImage(this.element, {
      target: '.block-content',
    });
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
